<app-main-header [name_main]="'Atributos de producto'"></app-main-header>

<div class="attribute-page-container">
 
  <div class="attribute-menu-box">
    <div
      *ngFor="let attr of formAttribConfig"
      (click)="selectAttribute(attr.controlName)"
      [class.active]="selectedAttribute === attr.controlName"
      class="menu-item"
    >
      {{ attr.label }}
      <div class="underline"></div>
    </div>
  </div>

  
  <div class="attribute-table-container">
    <router-outlet name="table"></router-outlet>
  </div>
</div>

